export enum UuidType {
   'person' = 'person',
   'membershipValidation' = 'membershipValidation'
}
